import Vue from 'vue'
import router from './router'
import store from './store'

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap')

const files = require.context('./', true, /\.vue$/i, 'lazy')

files.keys().map(key => {
	Vue.component(
		key
			.split('/')
			.pop()
			.split('.')[0],
		() => import(`${key}`)
	)
})

Vue.component('HasError', () => import('vform/src/components/HasError.vue'))
Vue.component('AlertError', () => import('vform/src/components/AlertError.vue'))
Vue.component('AlertErrors', () => import('vform/src/components/AlertErrors.vue'))
Vue.component('AlertSuccess', () => import('vform/src/components/AlertSuccess.vue'))
Vue.component('Multiselect', () => import('vue-multiselect/src/Multiselect.vue'))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
	el: '#app',
	store,
	router,
	// updated: () => init(),
})
